// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcm_a bhe_cw bhe_jx bhe_jo bhe_rh bhe_vf"};